import { Button, Dialog, Row } from "@narmi/design_system";
import ApiHttp from "byzantine/src/ApiHttp";
import CsrfTokenMiddleware from "cerulean/src/CsrfTokenMiddleware";
import { useState } from "react";

interface Props {
  kind?: "primary" | "secondary";
  showButton?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
}

const ImportModalButton = ({
  kind = "primary",
  showButton = false,
  isOpen: onMenuModalOpen,
  onClose: onMenuModalClose,
}: Props) => {
  const [buttonModalOpen, setButtonModalOpen] = useState(false);

  const isOpen = onMenuModalOpen !== undefined ? onMenuModalOpen : buttonModalOpen;
  const onClose =
    onMenuModalClose !== undefined ? onMenuModalClose : () => setButtonModalOpen(false);
  const openModal = () => setButtonModalOpen(true);

  const actions = (
    <div style={{ float: "right" }} className="padding--right">
      <Row alignItems="center">
        <Row.Item shrink>
          <Button onClick={onClose} kind="negative" label="Cancel" />
        </Row.Item>
        <Row.Item shrink>
          <CsrfTokenMiddleware />
          <Button
            onClick={async () => {
              await ApiHttp.fetch("/api/products/sync_uat", {
                method: "POST",
                endpointIsUrl: true,
              });
              onClose();
            }}
            label="Yes, import online products"
          />
        </Row.Item>
      </Row>
    </div>
  );
  return (
    <>
      {showButton && <Button onClick={openModal} kind={kind} label="Import product list" />}
      <Dialog
        isOpen={isOpen}
        title="Import online products"
        footer={actions}
        onUserDismiss={onClose}
      >
        <div>
          <span>
            Are you sure you want to import the product list from UAT? This will override all
            existing products for the online AO channel.
          </span>
        </div>
      </Dialog>
    </>
  );
};

export default ImportModalButton;
